import type { SectionLocale } from '../types'

export const PROFILES_LOCALE: SectionLocale = [
  [
    'profiles_thank',
    {
      ru: 'Поблагодарить',
      en: 'Thank',
    },
  ],
  [
    'profiles_main',
    {
      ru: 'Основное',
      en: 'Main',
    },
  ],
  [
    'profiles_work',
    {
      ru: 'О работе',
      en: 'Work',
    },
  ],
  [
    'profiles_contacts',
    {
      ru: 'Контакты',
      en: 'Contacts',
    },
  ],
  [
    'profiles_additions',
    {
      ru: 'Дополнительно',
      en: 'Addition',
    },
  ],
  [
    'profiles_birthdate',
    {
      ru: 'Дата рождения',
      en: 'Date of Birth',
    },
  ],
  [
    'profiles_boss',
    {
      ru: 'Руководитель',
      en: 'Head of department',
    },
  ],
  [
    'profiles_position',
    {
      ru: 'Должность',
      en: 'Position',
    },
  ],
  [
    'profiles_department',
    {
      ru: 'Отдел (подразделение)',
      en: 'Department (division)',
    },
  ],
  [
    'profiles_back',
    {
      ru: 'Назад к сотрудникам',
      en: 'Back to employees',
    },
  ],
  [
    'profiles_search_not_found',
    {
      ru: 'Сотрудники не найдены',
      en: 'Employees not found',
    },
  ],
  [
    'profile_info_no_data',
    {
      ru: 'Нет данных',
      en: 'No data',
    },
  ],
  [
    'thanks_dialog_title',
    {
      ru: 'Благодарность',
      en: 'Thanks',
    },
  ],
  [
    'thanks_send',
    {
      ru: 'Отправить',
      en: 'Send',
    },
  ],
  [
    'thanks_amount',
    {
      ru: 'Количество',
      en: 'Amount',
    },
  ],
  [
    'thanks_to',
    {
      ru: 'Кому',
      en: 'To',
    },
  ],
  [
    'thanks_category',
    {
      ru: 'Категория',
      en: 'Category',
    },
  ],
  [
    'thanks_comment',
    {
      ru: 'Комментарий',
      en: 'Comment',
    },
  ],
  [
    'thanks_not_enough',
    {
      ru: 'У вас недостаточно средств для благодарности',
      en: 'Not enough coins',
    },
  ],
  [
    'thanks_amount_max',
    {
      ru: 'Число должно быть',
      en: 'Amount should be',
    },
  ],
  [
    'thanks_for_help',
    {
      ru: 'Благодарность за помощь',
      en: 'Thanks for the help',
    },
  ],
  [
    'thanks_mentoring',
    {
      ru: 'Наставничество',
      en: 'Mentoring',
    },
  ],
  [
    'thanks_high_quality',
    {
      ru: 'За высокое качество работы',
      en: 'For the high quality work',
    },
  ],
  [
    'thanks_congratulations',
    {
      ru: 'Поздравление',
      en: 'Congratulations',
    },
  ],
  [
    'thanks_reward',
    {
      ru: 'Награда',
      en: 'Reward',
    },
  ],
  [
    'thanks_correction',
    {
      ru: 'Начисление коинов',
      en: 'Coin accrual',
    },
  ],
  [
    'thanks_encouragement',
    {
      ru: 'Поощрение',
      en: 'Encouragement',
    },
  ],
  [
    'thanks_send_successfully',
    {
      ru: 'Коины успешно отправлены',
      en: 'Coins successfully sent',
    },
  ],
  [
    'thanks_send_error',
    {
      ru: 'Ошибка при отправке коинов. Обратитесь к администратору',
      en: 'Error sending coins. Contact the administrator',
    },
  ],
  [
    'profile_delete_photo_title',
    {
      ru: 'Удаление фотографии',
      en: 'Delete photo',
    },
  ],
  [
    'profile_delete_photo_message',
    {
      ru: 'Вы хотите удалить из профиля эту фотографию? Можно загрузить другую',
      en: 'Do you want to remove this photo from the profile? You can upload another one',
    },
  ],
  [
    'profile_photo_upload_error',
    {
      ru: 'Не удалось загрузить фото',
      en: 'Failed to upload photo',
    },
  ],
  [
    'profile_photo_delete_error',
    {
      ru: 'Не удалось удалить фото',
      en: 'Failed to delete photo',
    },
  ],
  [
    'profile_photo_size_error',
    {
      ru: 'Размер файла не должен превышать 5 МБ',
      en: 'File size must not exceed 5 MB',
    },
  ],
  [
    'profiles_search_placeholder',
    {
      ru: 'Найти коллегу',
      en: 'Find a colleague',
    },
  ],
  [
    'profiles_sort_placeholder',
    {
      ru: 'Сортировать',
      en: 'Sort',
    },
  ],
  [
    'profiles_balance_management',
    {
      ru: 'Начисление коинов',
      en: 'Coin accrual',
    },
  ],
  [
    'profiles_allocate_coins',
    {
      ru: 'Начисление',
      en: 'Allocate',
    },
  ],
  [
    'profiles_withdraw_coins',
    {
      ru: 'Списание',
      en: 'Withdraw',
    },
  ],
]
